import { render, staticRenderFns } from "./WebResourceRequestList.vue?vue&type=template&id=4d56012c&scoped=true"
import script from "./WebResourceRequestList.vue?vue&type=script&lang=ts"
export * from "./WebResourceRequestList.vue?vue&type=script&lang=ts"
import style0 from "./WebResourceRequestList.vue?vue&type=style&index=0&id=4d56012c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d56012c",
  null
  
)

export default component.exports